import a, { useState as b, useLayoutEffect as y, createContext as v, useContext as W, useEffect as p } from "react";
import { useTheme as w, Paper as A, Box as S, useMediaQuery as P, Snackbar as T } from "@mui/material";
import { useTheme as B } from "@mui/material/styles";
import { s as R, u as x, c as q, A as z, a as I, b as L, g as Q } from "./chunk.CYIRpff0.js";
const $ = (e) => {
  const t = w(), s = R(e.severity, t), o = t.spacing(43), c = t.spacing(2), l = 6, m = t.spacing(2), f = Q().width;
  function r(u) {
    return Number(u.slice(0, -2));
  }
  const n = r(o) - 2 * r(c) - r(f) - r(m) - l, [i, d] = b(!1), [C, h] = x(e.action), [E, g] = x();
  return y(() => {
    n > 0 && e.action && d(
      q(
        e.message,
        t,
        h,
        n,
        g
      )
    );
  }, [e.message, h, n, g]), /* @__PURE__ */ a.createElement(
    A,
    {
      elevation: 6,
      sx: {
        boxSizing: "border-box",
        color: t.palette.text.primary,
        borderRadius: "4px",
        width: t.spacing(43),
        padding: t.spacing(2),
        borderLeft: `6px solid ${s.color}`,
        display: "flex",
        alignItems: "flex-start",
        gap: 2
      }
    },
    s.icon,
    /* @__PURE__ */ a.createElement(S, { sx: { width: "100%", flexGrow: 1, minWidth: 0 } }, /* @__PURE__ */ a.createElement(
      z,
      {
        closeButtonRef: E,
        onClose: (...u) => e.onClose && e.onClose(...u)
      }
    ), /* @__PURE__ */ a.createElement(
      I,
      {
        shouldWrap: i,
        message: e.message,
        maxWidth: (
          // TODO: Hard-code button width for now, but must use variables on v2
          // Can't use button ref because it takes too long with transition
          n - 24 - parseInt(t.spacing(2))
        )
      }
    ), e.action && /* @__PURE__ */ a.createElement(
      L,
      {
        onClose: (...u) => e.onClose && e.onClose(...u),
        ctaRef: C,
        action: e.action,
        shouldWrap: i
      }
    ))
  );
}, D = (e) => {
  const t = B(), s = P(t.breakpoints.down("sm"));
  return /* @__PURE__ */ a.createElement(
    T,
    {
      anchorOrigin: s ? { vertical: "bottom", horizontal: "center" } : { vertical: "top", horizontal: "right" },
      autoHideDuration: 6e3,
      open: e.open,
      onClose: (o, c) => {
        c !== "clickaway" && e.onClose && e.onClose(o, c);
      },
      TransitionProps: { onExited: e.onExited }
    },
    /* @__PURE__ */ a.createElement(S, null, /* @__PURE__ */ a.createElement($, { ...e }))
  );
}, k = v({
  enqueueSnackbar: (e) => {
    throw new Error(
      "Cannot enqueue snackbar. Did you wrap your app in a SnackbarProvider?"
    );
  }
}), _ = () => W(k);
function F(e) {
  const [t, s] = b(!1), [o, c] = b(
    null
  ), [l, m] = b([]);
  p(() => {
    l.length && !o && (c(l[0]), m((n) => n.slice(1)), s(!0));
  }, [l, o]);
  const f = (n) => {
    m((i) => [...i, n]);
  }, r = {
    enqueueSnackbar: (n) => f(n)
  };
  return /* @__PURE__ */ a.createElement(k.Provider, { value: r }, e.children, o ? /* @__PURE__ */ a.createElement(
    D,
    {
      open: t,
      ...o,
      onClose: (n, i) => {
        var d;
        s(!1), (d = o.onClose) == null || d.call(o, n, i);
      },
      onExited: () => {
        c(null);
      }
    }
  ) : /* @__PURE__ */ a.createElement(a.Fragment, null));
}
export {
  $ as S,
  F as a,
  _ as u
};
